module.exports = __webpack_public_path__ + "static/img/xqhz_4.f359ae1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xqhz/xqhz_4.png
// module id = /3Oa
// module chunks = 139